var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "706.65 433.15 46.9 58.7",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M716.1,487.8c-1.5,0-2.8-0.5-3.8-1.6c-1.1-1.1-1.6-2.3-1.6-3.8V459c0-1.5,0.5-2.8,1.6-3.8   c1.1-1.1,2.3-1.6,3.8-1.6h2v-4.3c0-3.4,1.2-6.2,3.5-8.6c2.4-2.4,5.2-3.5,8.5-3.5c3.3,0,6.2,1.2,8.5,3.5c2.4,2.4,3.5,5.2,3.5,8.6   v4.3h2c1.5,0,2.8,0.5,3.8,1.6c1.1,1.1,1.6,2.3,1.6,3.8v23.4c0,1.5-0.5,2.8-1.6,3.8c-1.1,1.1-2.3,1.6-3.8,1.6H716.1z M716.1,482.4   h28.1V459h-28.1V482.4z M733.5,474c0.9-0.9,1.4-2,1.4-3.4s-0.5-2.4-1.4-3.4c-0.9-0.9-2-1.4-3.4-1.4s-2.4,0.5-3.4,1.4   c-0.9,0.9-1.4,2-1.4,3.4s0.5,2.4,1.4,3.4c0.9,0.9,2,1.4,3.4,1.4S732.6,475,733.5,474z M723.5,453.6h13.4v-4.3   c0-1.9-0.6-3.5-1.9-4.8c-1.3-1.3-2.9-2-4.7-2s-3.4,0.7-4.7,2c-1.3,1.3-1.9,2.9-1.9,4.8V453.6z M716.1,482.4V459V482.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.eb0d60958cf14b8ae1344194ab920db3.svg";
export { ForwardRef as ReactComponent };